// Inbox Response Time Analytics — standalone admin page

import { useState } from 'react';
import InboxResponseTimePanel from '../components/statistics/InboxResponseTimePanel';
import styles from './InboxAnalyticsPage.module.css';

type DateRange = '30d' | '90d' | '6m' | '1y' | 'all';

function getDateRange(range: DateRange): { from: Date; to: Date } {
  const to = new Date();
  const from = new Date();
  if (range === '30d') from.setDate(from.getDate() - 30);
  else if (range === '90d') from.setDate(from.getDate() - 90);
  else if (range === '6m') from.setMonth(from.getMonth() - 6);
  else if (range === '1y') from.setFullYear(from.getFullYear() - 1);
  else from.setFullYear(2020);
  return { from, to };
}

export function InboxAnalyticsPage() {
  const [dateRange, setDateRange] = useState<DateRange>('90d');
  const { from, to } = getDateRange(dateRange);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>Inbox Response Analytics</h1>
          <p className={styles.subtitle}>
            Track how quickly staff respond to incoming emails
          </p>
        </div>
        <div className={styles.controls}>
          <label className={styles.label}>Period:</label>
          <select
            className={styles.select}
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value as DateRange)}
          >
            <option value="30d">Last 30 Days</option>
            <option value="90d">Last 90 Days</option>
            <option value="6m">Last 6 Months</option>
            <option value="1y">Last Year</option>
            <option value="all">All Time</option>
          </select>
        </div>
      </div>

      <InboxResponseTimePanel dateFrom={from} dateTo={to} />
    </div>
  );
}
